import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  openMagicDrawer,
} from 'redux/actions'

import Component from './component'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      openMagicDrawer,
    },
    dispatch
  ),
})

export default connect(null, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/ShareButton/index.js